export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#0B0807]/90 backdrop-blur-md border-t border-white/10 px-4 sm:px-8 lg:px-12 pt-16 pb-8"
        >
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                <div className="lg:col-span-5">
                    <a
                        href="#hero"
                        className="flex items-center gap-3 group"
                        data-testid="footer-logo"
                    >
                        <img
                            src="/duha-monogram.png"
                            alt="DUHA"
                            className="h-12 w-auto"
                        />
                        <span className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-[#F5EFE6]">
                            DUHA<span className="text-[#D69331]">.</span>
                        </span>
                    </a>
                    <p className="mt-4 font-mono-text text-sm text-zinc-400 leading-relaxed max-w-md">
                        Malaysia-based international trading company building
                        efficient global trade ecosystems across ASEAN, the
                        Middle East, Oceania and North America.
                    </p>
                </div>

                <div className="lg:col-span-3">
                    <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                        Navigate
                    </span>
                    <ul className="mt-4 space-y-2 font-mono-text text-sm">
                        {[
                            { href: "#about", label: "About" },
                            { href: "#services", label: "Services" },
                            { href: "#markets", label: "Markets" },
                            { href: "#supply-chain", label: "Supply Chain" },
                            { href: "#vision", label: "Vision" },
                        ].map((l) => (
                            <li key={l.href}>
                                <a
                                    href={l.href}
                                    data-testid={`footer-link-${l.label
                                        .toLowerCase()
                                        .replace(/\s+/g, "-")}`}
                                    className="text-zinc-300 hover:text-[#D69331] transition-colors"
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-4">
                    <span className="font-mono-text text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                        Contact
                    </span>
                    <a
                        href="mailto:info@duhagt.com"
                        data-testid="footer-email"
                        className="mt-4 block font-display uppercase text-xl sm:text-2xl text-white hover:text-[#D69331] transition-colors break-all"
                    >
                        info@duhagt.com
                    </a>
                    <p className="mt-3 font-mono-text text-xs text-zinc-500 leading-relaxed">
                        DUHA GLOBAL TRADING SDN. BHD.
                        <br />
                        Kuala Lumpur · Malaysia
                    </p>
                </div>
            </div>

            <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 font-mono-text text-[10px] uppercase tracking-[0.25em] text-zinc-500">
                <span>
                    © {year} DUHA Global Trading Sdn. Bhd. All rights reserved.
                </span>
                <span className="flex items-center gap-2">
                    <span className="inline-block h-2 w-2 bg-[#D69331] animate-pulse" />
                    Active across 5 regions
                </span>
            </div>
        </footer>
    );
};
